import React from 'react';
import LoadingSpinner from './LoadingSpinner';

interface FormActionButtonProps {
  testId?: string;
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  children: React.ReactNode;
}

const FormActionButton: React.FC<FormActionButtonProps> = ({
  testId,
  onClick,
  disabled = false,
  isLoading = false,
  children,
}) => {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`pointer-events-auto rounded-[20px] min-w-[200px] bg-white border border-solid border-[#1b1a30] px-[.75rem] py-[1rem] font-semibold leading-5 text-[#1b1a30] shadow-[3px_4px_0_0_#1b1a30] hover:text-[#f4f2f1] hover:border-[#f4f2f1] hover:bg-[#1b1a30] active:shadow-none font-[nimbus-sans-extended,sans-serif] uppercase transition-shadow duration-200 ${
        isLoading ? 'cursor-not-allowed shadow-none opacity-100 bg-[#1b1a30] hover:border-[#1b1a30]' : ''
      } ${`disabled:cursor-not-allowed disabled:bg-white disabled:shadow-none disabled:border-[#1b1a30] disabled:text-[#1b1a30]`}`}
    >
      {isLoading ? <LoadingSpinner darkMode={true} /> : children}
    </button>
  );
};

export default FormActionButton;
